import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  addItemToWishlist,
  getWishlistItems,
  removeItemFromWishlist,
} from "../actions/wishListActions";
import { ScrollToTop } from "../components/ScrollToTop";
import {
  Icon,
  useDisclosure,
} from "@chakra-ui/react";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { addItemToCart } from "../actions/cartActions";
import { listSizes } from "../actions/sizeActions";
import { serverIp } from "../config/conf";
import axios from "axios";
import CartDrawer from "../components/CartDrawer";
import { ProductCard } from "../components/ProductSlider";


export default function Wishlist() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [qty, setQty] = useState(1);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isBuyNow, setIsBuyNow] = useState(false);
  const [selectedPlating, setSelectedPlating] = useState([]);
  const [engravingTextMen, setEngravingTextMen] = useState(""); // State for engraving text
  const [engravingTextWomen, setEngravingTextWomen] = useState("");
  const [selectedSizeMen, setSelectedSizeMen] = useState("");
  const [selectedSizeWomen, setSelectedSizeWomen] = useState("");
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [productSet, setProductSet] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItemBasePrice, setSelectedItemBasePrice] = useState([]);
  const [allowRingSize, setAllowRingSize] = useState(false);
  const [allowAnkletType, setAllowAnkletType] = useState(false);
  const [price, setPrice] = useState(0);
  const [basePrice, setBasePrice] = useState(0);
  const [isPair, setIsPair] = useState(false);
  const [allowBraceletSize, setAllowBraceletSize] = useState(false);
  const [selectedBraceletSizeMen, setSelectedBraceletSizeMen] = useState("");
  const [selectedBraceletSizeWomen, setSelectedBraceletSizeWomen] =
    useState("");
  const [finalAmount, setfinalAmount] = useState(0);
  const [itemPer, setItemPer] = useState(selectedProduct?.setItemsPer || 2);

  const { id: productId } = useParams();
  // let qty = searchParams.get("qty");
  let size = searchParams.get("size");

  const notify = (link, content, type) =>
    type(<RouterLink to={link}>{content}</RouterLink>);

  const wishlist = useSelector((state) => state.wishlist);
  const { wishlistItems, successRemove, successAdd } = wishlist;

  const [localWishlistItems, setLocalWishlistItems] = useState([]);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const sizeList = useSelector((state) => state.sizeList);
  const { loading: loadingSize, error: errorSize, sizes } = sizeList;


  const [selectedAnkletSize, setSelectedAnkletSize] = useState("");


  //********** For Pet *************//

  const [frontPetTexts, setFrontPetTexts] = useState([]);
  const [petTypesSelected, setPetTypesSelected] = useState([]);
  const [backPetTexts, setBackPetTexts] = useState([]);
  const [breedAge, setBreedAge] = useState([]);
  const [breedSize, setBreedSize] = useState([]);

  const handlePetFrontEngChange = (text, index) => {
    const updated = [...frontPetTexts];
    updated[index] = text;
    setFrontPetTexts(updated);
  };

  const handlePetTypeChange = (pet, index) => {
    const updated = [...petTypesSelected];
    updated[index] = pet;
    setPetTypesSelected(updated);
  };

  const handlePetBackEngChange = (text, index) => {
    const updated = [...backPetTexts];
    updated[index] = text;
    setBackPetTexts(updated);
  };


  const handleBreedAgeChange = (text, index) => {
    const updated = [...breedAge];
    updated[index] = text;
    setBreedAge(updated);
  };

  const handleBreedSizeChange = (text, index) => {
    const updated = [...breedSize];
    updated[index] = text;
    setBreedSize(updated);
  };

  useEffect(() => {
    // console.log("selectedProduct", selectedProduct);
    if (
      selectedProduct
      &&
      selectedProduct.productCollections?.some(cat => cat.name === "Pet Collection") &&
      selectedProduct.canEngrave && selectedProduct.canBackEng
    ) {
      const q = qty || 1;

      console.log("In Pet Collection Wishlist");

      setFrontPetTexts(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });

      setPetTypesSelected(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push(null);
        return updated.slice(0, q);
      });

      setBackPetTexts(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });

      setBreedAge(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });

      setBreedSize(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });
    }
  }, [qty]);


  useEffect(() => {
    
    dispatch(listSizes());
    if (!userInfo) {
      // navigate("/signup");
      const localWishlist = JSON.parse(localStorage.getItem("savedWishlist")) || [];
      setLocalWishlistItems(localWishlist);

      const handleUpdate = () => {
        const localWishlist = JSON.parse(localStorage.getItem("savedWishlist")) || [];
        setLocalWishlistItems(localWishlist);
      };

      window.addEventListener("localWishlistUpdated", handleUpdate);

      // cleanup listener
      return () => {
        window.removeEventListener("localWishlistUpdated", handleUpdate);
      };
    } else {
      dispatch(getWishlistItems());
    }
  }, [dispatch, successRemove, successAdd, userInfo]);


  useEffect(() => {


    if (selectedProduct) {
      const hasAnkletsCategory = selectedProduct?.categories?.some(
        (category) => category.name === "ANKLETS"
      );

      const isValidProductsArray =
        Array.isArray(selectedProduct?.products) &&
        !selectedProduct.products.some((item) => typeof item === "string");

      const saiaProduct = isValidProductsArray
        ? selectedProduct.products.find((item) => item.sku.includes("SAIA"))
        : null;

      const price = hasAnkletsCategory
        ? isPair
          ? selectedProduct.price * 2
          : selectedProduct.price
        : saiaProduct
          ? isPair
            ? selectedProduct.price + saiaProduct.price
            : selectedProduct.price
          : selectedProduct.price;

      const basePrice = hasAnkletsCategory
        ? isPair
          ? selectedProduct.basePrice * 2
          : selectedProduct.basePrice
        : saiaProduct
          ? isPair
            ? selectedProduct.basePrice + saiaProduct.basePrice
            : selectedProduct.basePrice
          : selectedProduct.basePrice;

      setPrice(price);
      setBasePrice(basePrice);
    }
  }, [isPair, selectedProduct]);

  const removeItemFromWishlistHandler = (id) => {
    dispatch(removeItemFromWishlist(id));
  };

  const addItemToWishlistHandler = (productId) => {
    dispatch(addItemToWishlist(productId));
    notify("/wishlist", "Item Added To Wishlist", toast.success);
  };

  const handleContinue = () => {
    navigate("/");
  };

  const handleAccordionToggle = (isOpen) => {
    setIsAccordionOpen(isOpen); // Toggle Accordion state
    if (!isOpen) {
      setEngravingTextMen(""); // Clear engraving text when Accordion is closed
      setEngravingTextWomen(""); // Clear engraving text when Accordion is closed
    }
  };

  const handleQuantityChange = (value) => {
    if (value >= 1 && value <= 5) {
      setQty(value);
    }
  };

  const uploadImageHandler = async (e, setImageCallback) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);
    // setUploading(true);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await axios.post(
        `${serverIp}/api/uploads/single`,
        formData,
        config
      );

      // Use the passed callback to set the image URL
      setImageCallback(data.file);

      // setUploading(false);
    } catch (err) {
      console.error(err);
      // setUploading(false);
    }
  };

  const handleEngravingInput = (value, gender) => {
    const lettersAndSpaces = /^[A-Za-z ]*$/; // Regex to allow only letters and spaces
    if (lettersAndSpaces.test(value)) {
      if (gender === "female"|| gender === "unisex") {
        setEngravingTextWomen(value); // Update engraving text if input is valid
      } else {
        setEngravingTextMen(value); // Update engraving text if input is valid
      }
    }
  };

  const handleAddToCart = (obj) => {
    // e.preventDefault();
    const addToCart = () => {
      dispatch(addItemToCart(obj));
      // Check if the item exists in the wishlist
      const isInWishlist = wishlistItems?.some((item) => item._id === obj.product);

      if (isInWishlist) {
        dispatch(removeItemFromWishlist(obj.product));
      }
      onClose();
      if (isBuyNow) {
        setIsBuyNow(false);
        navigate("/cart");
      } else {
        notify("/cart", "Item Added To Cart", toast.success);
      }
    };

    // console.log("Select Product ---> ", selectedProduct);

    const categories = selectedProduct.categories?.map(c => c.name?.toLowerCase()) || [];
    const subcategories = selectedProduct.subcategories?.map(s => s.name?.toLowerCase()) || [];

    const isListString = (list) => {
      return Array.isArray(list) && list.every(item => typeof item === 'string');
    };

    const isRings = categories.includes("rings");
    const isBracelets = categories.includes("bracelets");
    const isAnklets = categories.includes("anklets");
    const isCoupleRing = subcategories.includes("couple rings");
    const isCoupleBracelets = subcategories.includes("for couples");
    const isSets = categories.includes("jewellery sets");
    const isMale = selectedProduct.gender?.toLowerCase() === "male";

    // const details = selectedProduct.product;

    if (isSets && productSet.length > 0 && productSet.length < 2) {
      notify("#", "Please Select Min 2 Items in Customized Set", toast.error);
      return;
    }

    if (isRings && isCoupleRing && (selectedSizeMen === "" || selectedSizeWomen === "")) {
      notify("#", "Select Both Ring Size", toast.error);
      return;
    }

    if (isRings && isMale && selectedSizeMen === "") {
      notify("#", "Select Ring Size", toast.error);
      return;
    }

    if ((isRings ||
      (isSets && productSet.length === 0) ||
      (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIR")))
    ) && !isMale && selectedSizeWomen === "") {
      notify("#", "Select Ring Size", toast.error);
      return;
    }

    if (
      (isAnklets ||
        (isSets && productSet.length === 0 &&
          !isListString(selectedProductDetails) &&
          selectedProduct.products?.some(e => e.sku?.includes("SAIA"))) ||
        (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIA")))
      ) && selectedAnkletSize === ""
    ) {
      notify("#", "Select Anklet Size", toast.error);
      return;
    }

    if (isBracelets && isCoupleBracelets && (selectedBraceletSizeWomen === "" || selectedBraceletSizeMen === "")) {
      notify("#", "Select Both Bracelets Size", toast.error);
      return false;
    }

    if (isBracelets && isMale && selectedBraceletSizeMen === "") {
      notify("#", "Select Bracelets Size", toast.error);
      return false;
    }

    if (
      (isBracelets ||
        (isSets && productSet.length === 0 &&
          !isListString(selectedProductDetails) &&
          selectedProduct.products?.some(e => e.sku?.includes("SAIB"))) ||
        (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIB")))
      ) && !isMale && selectedBraceletSizeWomen === ""
    ) {
      notify("#", "Select Bracelets Size", toast.error);
      return false;
    }

    if (selectedProduct.canImgEng && selectedProduct.canBackEng) {
      if (petTypesSelected.includes(null) || petTypesSelected.length === 0 || petTypesSelected.includes('')) {
        notify("#", "Please Select Breed", toast.error);
        return;
      }

      if (breedSize.includes('')) {
        notify("#", "Please Select Size", toast.error);
        return;
      }

      if (breedAge.includes('')) {
        notify("#", "Please Select Your Pet Age", toast.error);
        return;
      }

      if (frontPetTexts.includes('')) {
        notify("#", "Enter Front Engraving Characters", toast.error);
        return;
      }

      if (backPetTexts.includes('')) {
        notify("#", "Enter Back Engraving Characters", toast.error);
        return;
      }
    }

    // All validations passed — add to cart
    addToCart();

  };

  const totalPrice = selectedItems.reduce((sum, item) => {
    const price = item.sku.includes("SAIA")
      ? isPair
        ? item.itemPrice * 2
        : item.itemPrice
      : item.itemPrice;
    return sum + price;
  }, 0);

  const totalBasePrice = selectedItemBasePrice.reduce((sum, item) => {
    const basePrice = item.sku.includes("SAIA")
      ? isPair
        ? item.itemBasePrice * 2
        : item.itemBasePrice
      : item.itemBasePrice;
    return sum + basePrice;
  }, 0);

  useEffect(() => {
    let overallDiscount = Number(
      (
        ((selectedProduct?.basePrice - selectedProduct?.price) /
          selectedProduct?.basePrice) *
        100
      )?.toFixed(0)
    );

    if (selectedItems.length < 2) {
      // console.log(totalPrice);
      setfinalAmount(totalPrice);
    } else {
      // console.log("total price", totalBasePrice);
      let extraDiscount = (selectedItemBasePrice.length - 1) * itemPer;
      let finalDiscount = overallDiscount + extraDiscount;
      let discountedPrice = Number(
        (totalBasePrice - (totalBasePrice * finalDiscount) / 100).toFixed(0)
      );

      setfinalAmount(discountedPrice);
    }
  }, [selectedItemBasePrice, isPair]);

  const selectedProductDetails = {
    name: selectedProduct?.name,
    image:
      selectedProduct?.variants?.length > 0 &&
      selectedProduct?.variants?.filter((variant) =>
        selectedPlating.length > 0
          ? selectedPlating.includes(variant.color)
          : variant.isPrimary
      )[0]?.images[0],
    qty,
    sizeMen: selectedSizeMen,
    sizeWomen: selectedSizeWomen,
    price:
      productSet.length > 0
        ? finalAmount
        : selectedProduct?.products?.some((item) => item?.sku?.includes("SAIA"))
          ? price
          : selectedProduct?.price,
    basePrice:
      productSet.length > 0
        ? totalBasePrice
        : selectedProduct?.products?.some((item) => item?.sku?.includes("SAIA"))
          ? basePrice
          : selectedProduct?.basePrice,
    product: selectedProduct?._id,
    products: productSet,
    variant:
      selectedProduct?.variants?.length > 0 &&
      selectedProduct?.variants?.filter((variant) => variant?.isPrimary)[0]
        ?._id,
    sku: selectedProduct?.sku,
    giftWrap: false,
    message: "",
    engraveMen: engravingTextMen,
    engraveWomen: engravingTextWomen,
    isPair,
    braceletsSizeMen:
      selectedBraceletSizeMen,
    braceletsSizeWomen:
      selectedBraceletSizeWomen,
    ankletsSize: selectedAnkletSize,
    petFrontEng: frontPetTexts,
    petBackEng: backPetTexts,
    petEngImage: petTypesSelected,
    breedAge: breedAge,
    breedSize: breedSize,
  };

  // console.log(selectedProduct)

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  return (
    <div className="flex bg-white flex-col gap-2 max-w-full justify-center px-4 md:px-10 pb-4">
      <div className="mt-3">
        <h1 className="text-xl text-center md:text-2xl lg:text-3xl tracking-tight font-semibold leading-8 lg:leading-9 text-gray-800">
          My Wishlist
        </h1>
      </div>
      <div className="mt-4 lg:mt-6 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-x-2 gap-y-2">
        {(userInfo ? wishlistItems : localWishlistItems)?.length === 0 ? (
          <div className="flex flex-col gap-2 w-full items-center justify-center col-span-5">
            <h3 className="text-[#000080] text-base font-semibold">
              It feels so empty in here
            </h3>
            <img
              src="../../empty-wishlist.png"
              className="w-1/2 md:w-1/4"
              alt="It feels so empty in here"
              loading="lazy"
            />
          </div>
        ) : (
          (userInfo ? wishlistItems : localWishlistItems)?.map((product, index) => (
            <ProductCard
              prod={product}
              key={index}
              setSelectedProduct={setSelectedProduct}
              onOpen={onOpen}
              setIsBuyNow={setIsBuyNow}
              navigate={navigate}
              userInfo={userInfo}
              windowWidth={windowWidth} />
          ))
        )}
      </div>

      <CartDrawer
        isOpen={isOpen}
        onClose={onClose}
        selectedProductDetails={selectedProductDetails}
        handleAddToCart={handleAddToCart}
        qty={qty}
        handleQuantityChange={handleQuantityChange}
        selectedProduct={selectedProduct}
        productSet={productSet}
        setProductSet={setProductSet}
        selectedPlating={selectedPlating}
        sizes={sizes}
        loadingSize={loadingSize}
        errorSize={errorSize}
        selectedSizeMen={selectedSizeMen}
        setSelectedSizeMen={setSelectedSizeMen}
        selectedSizeWomen={selectedSizeWomen}
        setSelectedSizeWomen={setSelectedSizeWomen}
        selectedAnkletSize={selectedAnkletSize}
        setSelectedAnkletSize={setSelectedAnkletSize}
        isPair={isPair}
        setIsPair={setIsPair}
        selectedBraceletSizeMen={selectedBraceletSizeMen}
        setSelectedBraceletSizeMen={setSelectedBraceletSizeMen}
        selectedBraceletSizeWomen={selectedBraceletSizeWomen}
        setSelectedBraceletSizeWomen={setSelectedBraceletSizeWomen}
        allowRingSize={allowRingSize}
        setAllowRingSize={setAllowRingSize}
        allowBraceletSize={allowBraceletSize}
        setAllowBraceletSize={setAllowBraceletSize}
        allowAnkletType={allowAnkletType}
        setAllowAnkletType={setAllowAnkletType}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        selectedItemBasePrice={selectedItemBasePrice}
        setSelectedItemBasePrice={setSelectedItemBasePrice}
        totalPrice={totalPrice}
        totalBasePrice={totalBasePrice}
        engravingTextMen={engravingTextMen}
        engravingTextWomen={engravingTextWomen}
        handleEngravingInput={handleEngravingInput}
        isAccordionOpen={isAccordionOpen}
        handleAccordionToggle={handleAccordionToggle}
        uploadImageHandler={uploadImageHandler}
        petTypesSelected={petTypesSelected}
        handlePetTypeChange={handlePetTypeChange}
        frontPetTexts={frontPetTexts}
        handlePetFrontEngChange={handlePetFrontEngChange}
        backPetTexts={backPetTexts}
        handlePetBackEngChange={handlePetBackEngChange}
        breedAge={breedAge}
        handleBreedAgeChange={handleBreedAgeChange}
        breedSize={breedSize}
        handleBreedSizeChange={handleBreedSizeChange}
      />
      <div className="flex justify-center w-full px-4 my-10 lg:mb-0">
        <button
          className="flex items-center justify-center w-full md:w-1/5 p-2 md:p-3 text-[#000080] border border-[#000080] rounded-md hover:bg-[#000080] hover:border-[#000080] hover:text-gray-100"
          onClick={handleContinue}
        >
          Continue Shopping
        </button>
      </div>
    </div>
  );
}
